import {
  CUBICASA_UNSYNCED_LIST_REQUEST,
  CUBICASA_UNSYNCED_LIST_SUCCESS,
  CUBICASA_UNSYNCED_LIST_FAILED,
  CUBICASA_MARK_SYNCED_REQUEST,
  CUBICASA_MARK_SYNCED_SUCCESS,
  CUBICASA_MARK_SYNCED_FAILED,
  CUBICASA_SYNC_RESET,
} from "../../../_utils/constants/CubiCasa";

const initialState = {
  unSyncedList: [],
  count: 0,
  isLoading: false,
  isSuccess: false,
  errors: {},
  isSyncing: false,
  syncedResult: null,
  syncError: null,
};

const CubiCasaReducer = (state = initialState, action) => {
  switch (action.type) {
    case CUBICASA_UNSYNCED_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        errors: {},
      };
    case CUBICASA_UNSYNCED_LIST_SUCCESS:
      var decryptedData = action.payload;
      return {
        ...state,
        unSyncedList: decryptedData.result || [],
        count: decryptedData.count || 0,
        isLoading: false,
        isSuccess: true,
        errors: {},
      };
    case CUBICASA_UNSYNCED_LIST_FAILED:
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        errors: action.payload,
      };
    case CUBICASA_MARK_SYNCED_REQUEST:
      return {
        ...state,
        isSyncing: true,
        syncedResult: null,
        syncError: null,
      };
    case CUBICASA_MARK_SYNCED_SUCCESS:
      return {
        ...state,
        isSyncing: false,
        syncedResult: action.payload,
      };
    case CUBICASA_MARK_SYNCED_FAILED:
      return {
        ...state,
        isSyncing: false,
        syncError: action.payload,
      };
    case CUBICASA_SYNC_RESET:
      return {
        ...state,
        isSyncing: false,
        syncedResult: null,
        syncError: null,
      };
    default:
      return state;
  }
};

export default CubiCasaReducer;
